import React from 'react';
import { Card, CardHeader, EmptyState, ProgressBar, Skeleton } from '@opendate-app/setlist';
import { formatPercent } from '../../utils/dashboardUtils';
import { compactCurrency } from '../../utils/reportingUtils';

function VenuesCard({ venues, loading }) {
  const rows = venues || [];

  return (
    <Card header={<CardHeader title="Venues" supportingText="Sell-through for shows in range" />}>
      {loading && <Skeleton width="100%" height={140} />}
      {!loading && rows.length === 0 && <EmptyState size="sm" title="No shows in this range" />}
      {!loading && rows.map((venue) => (
        <div key={venue.id} style={{ marginBottom: 14 }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 13, marginBottom: 4 }}>
            <strong>{venue.name}</strong>
            <strong>{formatPercent(venue.sell_through)}</strong>
          </div>
          <ProgressBar value={venue.sell_through || 0} />
          <span style={{ fontSize: 12, color: 'var(--sl-text-tertiary)' }}>
            {`${venue.value.toLocaleString()} shows · ${compactCurrency(venue.net || 0)} net`}
          </span>
        </div>
      ))}
    </Card>
  );
}

export default VenuesCard;
